module.exports = __webpack_public_path__ + "media/Cow2.aed00266.ogg";